import { css } from "styled-components";

/** Case du prototype Jaangal : boîte 20px, rayon 6px, fond vert et coche blanche. */
export const checkboxInputCss = css`
	appearance: none;
	-webkit-appearance: none;
	width: 20px;
	height: 20px;
	margin: 0;
	flex-shrink: 0;
	box-sizing: border-box;
	border: 1.5px solid #e3e7ec;
	border-radius: 6px;
	background: #ffffff;
	position: relative;
	cursor: pointer;
	outline: none;
	transition:
		background 0.15s,
		border-color 0.15s;

	&::after {
		content: "";
		position: absolute;
		top: 50%;
		left: 50%;
		width: 13px;
		height: 13px;
		border: none;
		background: center / 13px 13px no-repeat
			url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='3'%3E%3Cpath d='M5 12l4 4 10-10'/%3E%3C/svg%3E");
		transform: translate(-50%, -50%) scale(0);
		opacity: 0;
		transition: 0.15s;
	}

	&:checked {
		background: var(--checkbox-color, #00863d);
		border-color: var(--checkbox-color, #00863d);

		&::after {
			transform: translate(-50%, -50%) scale(1);
			opacity: 1;
		}
	}

	&:disabled {
		cursor: default;
		opacity: 0.5;
	}
`;
